import React from 'react';
import { CalendarCheck, Target, Star, TrendingUp } from 'lucide-react';

const ICONS = {
  'calendar-check': CalendarCheck,
  'target': Target,
  'star': Star,
  'trending-up': TrendingUp,
};

/**
 * ParentMetricsRow — 3 unified KPI cards rendered consistently across all
 * 4 Parent Hub phases (Dashboard / Children / Enrollments / Parent Hub).
 *
 * `metrics` is the `unified_metrics` array from `GET /api/parent/hub/:id`.
 */
export const ParentMetricsRow = ({ metrics, loading, studentName }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4" data-testid="parent-metrics-row-loading">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="bg-white rounded-xl border border-slate-200 p-4 animate-pulse">
            <div className="h-3 w-24 bg-slate-200 rounded mb-2" />
            <div className="h-7 w-16 bg-slate-200 rounded" />
          </div>
        ))}
      </div>
    );
  }
  if (!Array.isArray(metrics) || metrics.length === 0) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4" data-testid="parent-metrics-row">
      {metrics.map((m) => {
        const Icon = ICONS[m.icon] || Target;
        return (
          <div
            key={m.key}
            className="relative bg-white rounded-xl border border-slate-200 p-4 overflow-hidden"
            data-testid={`parent-metric-${m.key}`}
          >
            <div
              className="absolute left-0 top-0 bottom-0 w-1.5"
              style={{ background: m.accent || '#3B82F6' }}
            />
            <div className="flex items-center gap-2 mb-1">
              <Icon className="w-4 h-4" style={{ color: m.accent || '#3B82F6' }} />
              <span className="text-xs font-bold text-[#334155] uppercase tracking-wider">{m.label}</span>
            </div>
            <div className="flex items-baseline gap-1">
              <span className="text-2xl font-extrabold text-[#0F172A]">{m.value ?? 0}</span>
              {m.suffix && <span className="text-sm font-bold text-[#64748B]">{m.suffix}</span>}
            </div>
            <p className="text-[11px] font-medium text-[#64748B] mt-0.5">
              {m.sub_label}{studentName ? ` · ${studentName}` : ''}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default ParentMetricsRow;
